import { FileText, Paperclip, Presentation, Video } from 'lucide-react';

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pl-PL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('pl-PL', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getAttachmentIcon = (type) => {
  switch (type) {
    case 'pdf': return FileText;
    case 'presentation': return Presentation;
    case 'video': return Video;
    default: return Paperclip;
  }
};
